import React from 'react'
import { Box, Typography, Button } from '@mui/material'
import { Link } from 'react-router-dom'

const NotFoundPage: React.FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        textAlign: 'center',
        bgcolor: 'background.paper',
        p: 3,
      }}
    >
      <Typography variant='h1' color='error' sx={{ mb: 2 }}>
        404
      </Typography>
      <Typography variant='h6' sx={{ mb: 4 }}>
        Oops! The page you’re looking for doesn’t exist.
      </Typography>
      <Button component={Link} to='/' variant='contained' color='primary'>
        Go to Home
      </Button>
    </Box>
  )
}

export default NotFoundPage
